import { defineStore } from 'pinia';
import { ApiError } from '~/graphql/wrappers/api-error';
import {
  EmailNotificationSubscriptionsDocument,
  UpdateEmailNotificationSubscriptionDocument,
} from '~/graphql';

export const emailNotificationSubscriptionCacheExchange = {
  optimistic: {
    updateUserEmailNotificationSubscription: () => {
      return {
        __typename: 'DoneResult',
        done: true,
      };
    },
  },
  updates: {
    Mutation: {
      updateUserEmailNotificationSubscription: (result, args, cache) => {
        cache.updateQuery(
          {
            query: EmailNotificationSubscriptionsDocument,
          },
          (data) => {
            if (data) {
              const notificationId = args.emailNotificationSubscriptionInput.emailNotificationId;
              const subscribed = args.emailNotificationSubscriptionInput.subscribed;
              for (let i = 0; i < data.userEmailNotificationSubscriptions.length; i++) {
                if (data.userEmailNotificationSubscriptions[i].notificationId === notificationId) {
                  data.userEmailNotificationSubscriptions[i].subscribed =
                    !data.userEmailNotificationSubscriptions[i].subscribed;
                }
              }
            }
            return data;
          }
        );
      },
    },
  },
};

export const useEmailNotificationSubscriptionManagement = defineStore(
  'emailNotificationSubscriptionManagement',
  () => {
    const { $urql } = useNuxtApp();

    const updateUserEmailNotificationSubscription = async (
      notificationId: string,
      subscribed: boolean
    ) => {
      const { error } = await $urql
        .mutation(UpdateEmailNotificationSubscriptionDocument, {
          emailNotificationSubscriptionInput: {
            emailNotificationId: notificationId,
            subscribed,
          },
        })
        .toPromise();
      if (error) {
        throw new ApiError(error);
      }
    };

    return {
      updateUserEmailNotificationSubscription,
    };
  }
);
